<template>
  <wrapper-edit class="paas-select-wrap"
    :wrapper-width="wrapperWidth"
    :content-padding = "contentPadding"
    offsetHeight="300"
    @back="paasPageBack">
    <div slot="head">
      <h6>图片空间</h6>
    </div>
    <div class="paas-split" slot="form">
      <Split v-model="split" :min="siderWidth" v-height="{offsetHeight:380}">
        <div slot="left" class="paas-split-pane" ref="treeWrap" >
          <wrapper-tree
            title="图片分类"
            ref="wrapperTree"
            icon = "iconfont iconnavicon-lcpz"
            :offsetHeight = "370"
            :serviceUrl="serviceUrl"
            :currentIdFiledName="categoryFiledName"
            :start-tree-node="startTreeCode"
            tree-node-icon="iconfont iconpaixing"
            treeType="query"
            @on-node-click="paasNodeClick">
          </wrapper-tree>
        </div>
        <Widget
          title="图片"
          icon="iconfont iconxitongguanli-jianchayiju"
          class="paas-split-pane"
          slot="right" >
          <div slot="toolbar" class="toolbar-wrap" >
            <Button type="primary" @click="showOrUpdateModal">添加分类</Button>
            <Button type="primary" @click="handleClick">
              <input class="paas-upload-input"
                     ref="paasUploadInput"
                     type="file"
                     @change="handleChange"
                     :multiple="multiple" />
              上传图片
            </Button>
            <!--<Button type="default"  disabled v-if="selectImgs.length === 0">选中当前项</Button>
            <Button type="primary" v-if="selectImgs.length > 0"  @click="confirmCheck">选中当前项</Button>-->
          </div>
          <div slot="content"  class="paas-select-right-image" v-height="{offsetHeight:380}">
            <div class="image-wrap">
              <Card
                v-for="(item,index) in fileList"
                :key="index" bordered
                @click.native ="selectCard(item)"
                :class="[item.check?'active-card':'','img-card']">
                <div style="text-align:center">
                  <img :src="item.thumbnailUrl?item.thumbnailUrl:item.originalUrl" width="100" height="100">
                  <p :title="item.name" class="file-name">{{item.name}}</p>
                </div>
              </Card>
            </div>

            <div class="page-footer" v-if="fileList.length > 0">
              <Page :total="totalNum" show-total show-sizer
                    @on-change="changePage"
                    @on-page-size-change="changePageSize"/>
            </div>
          </div>
        </Widget>
      </Split>
      <Modal
        v-model="categoryModal"
        class="category_modal"
        title="添加分类"
        @on-ok="addCategory"
        @on-cancel="cancel">
        <Form :model="categoryData" :label-width="80">
          <FormItem label="上级分类:" >
            <Input v-model="categoryData.paasTreeParentName"
                   @on-focus="showFlag=true"></Input>
            <select-tree ref="categoryTree"
                         @selected-tree-value="updateTreeParentNode"
                         serviceUrl='/sys/image/category'
                         v-show="showFlag"/>
          </FormItem>
          <FormItem label="分类名称:">
            <Input v-model="categoryData.sysImageCategoryName" placeholder="请输入分类名称"></Input>
          </FormItem>
        </Form>
      </Modal>
    </div>
  </wrapper-edit>

</template>

<script>
  import Widget from "@/components/paas/widget";
  import wrapperTree from '@/components/paas/wrapper-tree'
  import metaFile from "@/assets/js/file/meta-file.js";
  import wrapperEdit from "@/components/paas/wrapper-edit";
  import SelectTree from '@/components/paas/selectTree';
  import { getImagesByCategoryId } from "@api/upload.js";
  export default {
    name: "select",
    mixins:[metaFile],
    components:{Widget,wrapperTree,wrapperEdit,SelectTree},
    props:{
      multiple: {
        type: Boolean,
        default: false
      },
      //缩略图
      thumbnailWidth:{
        type:[Number,String],
        default: function () {
          return 0 ||'0px'
        }
      },
      thumbnailHeight:{
        type:[Number,String],
        default: function () {
          return 0 ||'0px'
        }
      },
      uploadParams:{
        type:Object,
        default:function(){
          return {};
        },
      },
      uploadAction:{
        type:String,
        default:'',
      },
      checkedFile:{
        type:Array,
        default:[],
      }
    },

    data(){
      return {
        serviceUrl:'/sys/image/category',
        wrapperWidth:'100%',
        contentPadding:'0px',
        siderWidth:"250px",  //sider的宽度，必须是String类型的
        treeHeight:'', //树的高度
        startTreeCode:'',  //起始树节点,只传paasLikeTreeCode的值 '100'、'101'等等
        split:0.3,  //面板位置，可以是 0~1 代表百分比，或具体数值的像素，可用 v-model 双向绑定
        categoryFiledName:'sysImageCategoryId',
        selectCategoryId:'',
        queryByCategoryParam:{
          sysImageCategoryId:"",
          iDisplayStart: 0, //从第几条记录开始
          iDisplayLength: 10, //查询的条数
          currentPageNum: 1  //当前页码
        },
        totalNum:0,
        selectImgs:[],
        fileList:[],

        categoryModal:false,
        categoryData:{
          paasTreeParentId:'',
          paasTreeParentName:'',
          sysImageCategoryName:'',
        },
        showFlag:false,
      }
    },
    created(){
      //根据分类获取图片
      this.getImagesByCategoryId();
      this.action = this.uploadAction;
      this.uploadParam = this.uploadParams;
    },
    watch:{
      uploadParams:{
        handler(newName, oriName) {
          this.uploadParam = newName;
        },
        // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
        immediate: true
      },
      uploadAction(newVal,oriVal){
        this.action = newVal;
      },
    },
    methods: {
      paasPageBack(){
        this.$emit("on-close");
      },
      /**
       * 添加分类
       * */
      addCategory() {
        let url = this.$store.state.sysApi + this.serviceUrl + "/saveCategory";
        this.axios.post(url, this.categoryData)
          .then(res => {
            if (res.code === 200) {
              //清空categoryData数据
              for (let key in this.categoryData) {
                this.categoryData[key] = "";
              }
              //同时更新一下tree数据
              this.$bus.emit("update-tree", "add", res);
              this.$Message.info('数据保存成功！');
            }
          }).catch(function (error) {
          this.$Message.error('数据保存失败！');
        });
      },
      /**
       * 点击添加分类：显示模态框、更新模态框的树表
       * */
      showOrUpdateModal(){
        this.clearAddCategoryModalData();
        this.categoryModal = true;
        this.$refs.categoryTree.queryTreeDatas();
      },
      /**
       * 清空添加分类的form的数据
       * */
      clearAddCategoryModalData(){
        for(let key in this.imageData){
          this.imageData[key] = "";
        }
      },
      /**
       * 选中父节点
       *
       * */
      updateTreeParentNode(node) {
        this.categoryData.paasTreeParentId = node.id;
        this.categoryData.paasTreeParentName = node.title;
        this.showFlag = false;
      },
      /**
       *
       * 监测到点击左侧树表
       * */
      paasNodeClick(node) {
        this.selectCategoryId = node.id;
        this.uploadParam.sysImageCategoryId = node.id;
        this.uploadParam.sysImageCategoryName = node.title;
        this.getImagesByCategoryId(node.id);
      },

     /**
       * 查询分类图片
       * @param id
       */
        getImagesByCategoryId(id) {
          if(id){
              this.queryByCategoryParam.query_EQ_businessId = id;
              getImagesByCategoryId(this.queryByCategoryParam).then(res =>{
                  if (res.code === 200) {
                    console.log(res)
                    let imageList = res.data;
                    this.selectImgs = [];
                    this.fileList = [];
                    imageList.map(((item, index)=> {
                      let check = false;
                      if(this.checkedFile != null && this.checkedFile.length > 0){
                        for(let i = 0; i < this.checkedFile.length; i++){
                          if(item.imageId === this.checkedFile[i].imageId){
                            check = true;
                            this.selectImgs.push(item);
                            break;
                          }
                        }
                      }
                      this.fileList.push(Object.assign({},item,{check:check}));
                    }));
                    this.totalNum = imageList.length;
                }
              });
          }
      },

      /**
       * 页码改变的回调，返回改变后的页码
       * @param currentPage
       */
      changePage (currentPage) {
        this.queryByCategoryParam.iDisplayStart = (currentPage - 1) * this.queryByCategoryParam.iDisplayLength;
        this.queryByCategoryParam.currentPageNum = currentPage;
        this.getImagesByCategoryId(this.selectCategoryId);
      },
      /**
       * 改变每页显示数量
       * @param pageSize
       */
      changePageSize (pageSize) {
        this.queryByCategoryParam.iDisplayLength = pageSize;
        this.getImagesByCategoryId(this.selectCategoryId);
      },
      /**
       * 选中卡片
       * @param item
       */
      selectCard(item){
        if(this.multiple){
          if(this.fileList != null && this.fileList.length > 0){
            for(let i = 0; i < this.fileList.length;i++){
              if(this.fileList[i].id === item.id){
                if(!this.fileList[i].check){
                  this.fileList[i].check = true;
                  this.selectImgs.push(this.fileList[i]);
                  this.$emit('save-file',this.selectImgs);
                }
              }
            }
          }
        }else{
          if(this.fileList != null && this.fileList.length > 0){
            for(let i = 0; i < this.fileList.length;i++){
              if(this.fileList[i].id === item.id){
                this.fileList[i].check = true;
                this.selectImgs = [];
                this.selectImgs.push(this.fileList[i]);
                this.$emit('save-file',this.selectImgs);
              }else{
                this.fileList[i].check = false;
              }
            }
          }
        }
      },

      handleClick() {
        this.$refs.paasUploadInput.click();
      },
      /**
       * 直接上传附件
       */
      handleChange(e){
        if (!this.selectCategoryId) {
          this.$Notice.warning({
            title: '上传文件请先选中分类！'
          });
          return;
        }
        const files = e.target.files;
        if (!files) {
          return;
        }
         //上传
         this.uploadFiles(files);
        this.$refs.paasUploadInput.value = null;
      },
      /**
       * 附件上传完的操作
       * @param file
       */
      uploadAfterLogic(file){
          this.selectImgs = [];
          this.selectImgs.push(file);
          this.fileList.push(file);
          this.$emit('save-file',this.selectImgs);
      }
    }
  }
</script>

<style scoped>
  .paas-split{
    padding:10px;
  }
  .paas-split >>> .wrapper{
    padding:0px;
  }
  .paas-split-pane,.paas-split >>> .paas-split-pane{
    padding-left:5px;
  }
  .toolbar-wrap{
    display: flex;
    align-items: flex-start;
    margin-top: -5px;
  }
  .toolbar-wrap > button{
    margin:0px 3px;
  }
  .page-footer{
    display:flex;
    justify-content:space-between;
    margin-top:10px;
  }
  .paas-upload-input {
    display: none;
  }
  .image-wrap{
    display:flex;
    flex-wrap: wrap;
    justify-content: flex-start
  }
  .file-name{
    width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .img-card{
    margin:5px;
  }
  .image-wrap > .active-card{
    border:1px solid red;
    background: #ffffff;
    opacity:0.6;
    filter: alpha(opacity=60);
  }
  .paas-select-right-image,.paas-split-pane >>> .content{
    overflow: auto;
  }
  .category_modal{
    z-index:99999;
  }
</style>
